export default {
    title: "Notification Sending Schedule",
    success_update: "Updated successfully",
    copy_instruction:
        "Select the days that will receive the previously copied schedule",
    main_description:
        "Define the times for sending notifications according to the days of the week, as well as the times related to the operation and/or service of the establishment",
    all: "All",
    copy: "Copy",
    cancel: "Cancel",
    save: "Save",
    success_copy: "Copied successfully!",
    error_save: "Error trying to save schedule data.",
    success_paste: "Pasted successfully!",
    browser_title: "Kevi | Automation Sending Schedules",
    unavailable: "Unavailable",
    add: "Add",
    remove: "Remove",
    days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
    },
};
